import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    selectedCompany: null,
    isLoggedIn: false, // 로그인 상태
    token: null, // 토큰 저장
    adminId: null,
  },
  mutations: {
    setLoginState(state, payload) {
      state.isLoggedIn = true;
      state.token = payload.token;
      state.adminId = payload.adminId;
      sessionStorage.setItem("token", payload.token); // 토큰 로컬 저장소에 저장
      sessionStorage.setItem("adminId", payload.adminId); // 토큰 로컬 저장소에 저장
    },
    // 로그아웃 처리
    logout(state) {
      state.isLoggedIn = false;
      state.token = null;
      state.adminId = null;
      sessionStorage.clear();
    },
  },
  actions: {
    // 로그인 액션
    login({ commit }, payload) {
      commit("setLoginState", payload);
    },
    // 로그아웃 액션
    logout({ commit }) {
      commit("logout");
    },
  },
  getters: {
    // 로그인 상태 반환
    isLoggedIn: (state) => state.isLoggedIn,
    token: (state) => state.token,
    adminId: (state) => state.adminId,
  },
  modules: {},
});
